import { Link } from 'react-router-dom';

const REVIEWS = [
  {
    name: '阿柚',
    role: '通勤党',
    text: '最喜欢它按板块分好，我只想看点轻松的，直接进娱乐区就行，不用在首页一堆标题里找。',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20woman%20with%20short%20hair%20on%20a%20warm%20beige%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=gua-review-01&orientation=squarish',
  },
  {
    name: '老陈',
    role: '数码爱好者',
    text: '科技圈那几篇把发布会参数翻译成人话，看完知道该关注什么，比刷十几条短评省事。',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20middle%20aged%20man%20with%20glasses%20on%20a%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=gua-review-02&orientation=squarish',
  },
  {
    name: '小满',
    role: '内容从业者',
    text: '网红圈的内容角度挺细，不是单纯复述热搜，会讲讲背后的生态变化，对我做选题很有帮助。',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20young%20creator%20with%20a%20notebook%20on%20a%20warm%20ivory%20background%2C%20soft%20daylight%2C%20editorial%20portrait%20photography&width=200&height=200&seq=gua-review-03&orientation=squarish',
  },
];

export default function BrandBand() {
  return (
    <section className="w-full bg-secondary-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="text-xs font-medium tracking-[0.25em] text-secondary-700">网站口碑</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              把吃瓜这件事，做得清爽一点
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              我们相信，追热点不等于被信息淹没。17吃瓜网坚持两个原则：一是按分区组织，让每个人都能只看自己想看的；
              二是把背景讲清楚，而不是丢一个标题就走。
            </p>
            <Link
              to="/about"
              className="mt-6 flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              了解我们的内容原则 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-7">
            {REVIEWS.map((review) => (
              <figure
                key={review.name}
                className="flex h-full flex-col rounded-lg border border-secondary-100 bg-background-50 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-secondary-400" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {review.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="h-10 w-10 overflow-hidden rounded-full">
                    <img src={review.avatar} alt={`${review.name}的头像`} className="h-full w-full object-top" />
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-foreground-950">{review.name}</span>
                    <span className="block text-xs text-foreground-500">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}